import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Seçili firma varsa company_id query parametresi ekle
  const selectedCompanyId = localStorage.getItem('selectedCompanyId')
  if (selectedCompanyId && selectedCompanyId !== 'all') {
    config.params = config.params || {}
    if (!config.params.company_id) {
      config.params.company_id = parseInt(selectedCompanyId)
    }
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.replace('/login')
    }
    return Promise.reject(error)
  }
)

export default api
